import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminApiService } from "../../../services/adminApiService";

interface AdminUsersState {
  usersListData: any[];
  usersListPagination: any;
  isLoadingList: boolean;
  error: string | null;
}

const initialState: AdminUsersState = {
  usersListData: [],
  usersListPagination: null,
  isLoadingList: false,
  error: null,
};

export const fetchAdminUsers = createAsyncThunk(
  "adminUsers/fetchUsers",
  async (params: any, { rejectWithValue }) => {
    try {
      return await adminApiService.getUsers(params);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const adminUsersSlice = createSlice({
  name: "adminUsers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminUsers.pending, (state) => {
        state.isLoadingList = true;
        state.error = null;
      })
      .addCase(fetchAdminUsers.fulfilled, (state, action) => {
        state.isLoadingList = false;
        state.usersListData = action.payload.data?.users || [];
        state.usersListPagination = action.payload.data?.pagination || null;
      })
      .addCase(fetchAdminUsers.rejected, (state, action) => {
        state.isLoadingList = false;
        state.error = action.payload as string;
      });
  },
});

export default adminUsersSlice.reducer;
